<template>
  <div>
    <p class="title">{{title}}</p>
    <div>
      <seletor :elements="elements"></seletor>
    </div>
  </div>
</template>
<script>

import Seletor from '../../seletor/Seletor'

export default {
  name: 'FilterComponentExemple',
  props: {
    title: {
      type: String,
      default: ''
    },
    elements: {
      type: Array,
      default: () => []
    }
  },
  components: {
    Seletor
  }
}
</script>
